import React from "react";
import Logo from "../../../common/logo/Logo";
import commitTags from "./assets/commit-tags.png";

function CommitTags() {
  return (
    <header className="app-header">
      <div className="app-container features-container">
        <div className="logo-box" style={{ marginBottom: "3rem" }}>
          <Logo navigateTo={"/GitVersioniser/start"} />
        </div>
        <div
          className="container"
          style={{ width: "100%", marginBottom: "3rem" }}
        >
          <div className="row flex">
            <div className="col-sm-12" style={{ alignSelf: "center" }}>
              <h1>Commit Tags</h1>
              <br />
              <p> Start Commit Message line with any pattern from the list. </p>
              <p> Multiple tags per commit message are supported. </p>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row flex">
            <div className="col-sm-12">
              <a href="https://github.com/Luzkan/GitVersioniser/blob/main/src/gitversioniser/config/patterns/commit_change_tags/changelog_category.py">
                <img
                  src={commitTags}
                  alt="Git Versioniser Logo"
                  className="feature-image"
                  style={{ width: "24em" }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default CommitTags;
